import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models/entities.enum';
import httpClient, { authorizeClient } from '@/api/http-client';
import {
    VimeoUpload,
    VimeoVideoApiFactory,
    InitVimeoVideoUploadCommand,
} from '@eloomi/eloomi-content-persona-client/1.0';
import { extractAxiosData } from '@/common/services/extractAxiosData';
import { VideoContent } from '@eloomi/eloomi-content-persona-client/1.0/models/video-content';

const VimeoClient = authorizeClient(VimeoVideoApiFactory);

export async function uploadVideo(data: FormData): Promise<VideoUploadResult> {
    const q = new CoreQuery();
    q.entity([EntitiesList.VIDEO, EntitiesList.QUEUE]);

    const response = await httpClient.post(q.query, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Eloomi-Video-Destination': 'VIMEO',
        },
    });
    const uploadResult = response.data;
    return {
        part: uploadResult.part,
        row: uploadResult.row,
    };
}

export function getUploadVideoContent(rowKey: string) {
    const q = new CoreQuery();
    q.entity([EntitiesList.VIDEO, EntitiesList.EMBED]).param({
        row_key: rowKey,
    });

    return httpClient.get(q.query, q.axiosConfigParams).then(({ data }) => {
        return data;
    });
}

export async function uploadVimeoVideo(command: InitVimeoVideoUploadCommand): Promise<VimeoUpload> {
    return VimeoClient.initUpload(command).then(extractAxiosData);
}

export function getUploadVimeoVideoContent(id: number): Promise<VideoContent> {
    return VimeoClient.getVideo(id).then(extractAxiosData);
}

export interface VideoUploadResult {
    part: number;
    row: string;
}
